/* LF V15 — corrigé textes CTA orphelins, favoris premium, FAQ après guides. */
(function(){'use strict';
const page=location.pathname.split('/').filter(Boolean).pop()||'';
function cleanOrphans(el,pattern){
 if(!el)return;
 Array.from(el.childNodes).forEach(node=>{
  if(node.nodeType===3&&pattern.test((node.textContent||'').trim()))node.remove();
 });
}
function link(className,label,url){
 const a=document.createElement('a');a.className=className;a.href=url;a.textContent=label;return a;
}
if(page==='coups-de-coeur')return;
if(page==='faq-luminaire-france'){
 const rte=document.querySelector('#MainContent .page-content rte-formatter');
 if(!rte)return;
 const tail=[...rte.querySelectorAll(':scope>p')];
 for(let i=tail.length-1;i>0;i--){
  if(tail[i].textContent.trim()===tail[i-1].textContent.trim())tail[i].remove();
 }
 rte.classList.add('lf-v15-faq-tail');return;
}
if(!document.querySelector('#MainContent[data-template*="page.guide"]'))return;
const root=document.querySelector('#MainContent .page-content rte-formatter > :is(.lf-guide,.lf-guide15,.lf-piece-guide,.lf-ambiance-guide,.lf-eco-guide)');
if(!root)return;
const area=root.querySelector('.lf-v15-guide-faq');
if(area){
 area.classList.add('lf-v15-guide-faq-finished');
 area.querySelectorAll('details').forEach((el,i)=>{
  const summary=el.querySelector('summary');
  if(summary)summary.setAttribute('aria-controls','lf-v15-faq-answer-'+page+'-'+i);
  const answer=el.querySelector('.lf-v15-faq-answer');
  if(answer)answer.id='lf-v15-faq-answer-'+page+'-'+i;
 });
}
})();